import React, { Fragment, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import { gameJoinAction } from '../../../../redux/actions/game.actions';
import Player from './player/component';
export default function PlayersSidebar() {
    var dispatch = useDispatch();
    var players = useSelector(function (state) { return state.general.players; });
    var player = useSelector(function (state) { return state.player; });
    var isMobilePlayerSelectionOpen = useSelector(function (state) { return state.userInterface.showMobilePlayerSelection; });
    var sidebarMobileRef = useRef(null);
    function onPlayerClick(id, token) {
        if (player.id !== id) {
            dispatch(gameJoinAction(token));
        }
    }
    function getWrapper() {
        var companyID = player.company.id;
        var thisCompPlayers = players.filter(function (p) { return p.companyID === companyID; });
        return (React.createElement("div", { className: "sidebar-players__wrapper" },
            React.createElement("div", { className: "sidebar-players__list" }, thisCompPlayers.map(function (compPlayer, index) { return (React.createElement(Player, { isActive: player.id === compPlayer.id, key: index, name: compPlayer.name, onClick: function () { return onPlayerClick(compPlayer.id, compPlayer.token); }, thumbnail: compPlayer.thumbnail })); }))));
    }
    return (React.createElement(Fragment, null,
        React.createElement("div", { className: "sidebar-players d-none d-block-md" }, getWrapper()),
        React.createElement(CSSTransition, { in: isMobilePlayerSelectionOpen, timeout: 100, classNames: "anim-righttoleft", unmountOnExit: true, nodeRef: sidebarMobileRef },
            React.createElement("div", { className: "sidebar-players", ref: sidebarMobileRef }, getWrapper()))));
}
